export type ColorWeight = 500 | 800;

export const colors = {
  neutral: {
    white: { value: '#FFFFFF' },
    100: { value: '#F0F5FB' },
    200: { value: '#CBD5E1' },
    300: { value: '#94A3B8' },
    500: { value: '#64748B' },
    600: { value: '#334155' },
    700: { value: '#283548' },
    750: { value: '#232F42' },
    800: { value: '#1E293B' },
    '800-op70': { value: '#1E293BB3' },
    850: { value: '#162131' },
    900: { value: '#0F172A' },
    '900-op30': { value: '#0F172A4D' },
    '900-op75': { value: '#0F172ABF' },
    '900-op80': { value: '#0F172ACC' },
    black: { value: '#020617' },
    'black-op50': { value: '#02061780' },
  },
  neutralBlue: {
    DEFAULT: { value: '#FFFFFF' },
    500: { value: '#FFFFFF' },
    800: { value: '#1561D1' },
  },
  red: {
    DEFAULT: { value: '#DE1A22' },
    100: { value: '#FCE8E9' },
    500: { value: '#DE1A22' },
    600: { value: '#9B1C21' },
    800: { value: '#582534' },
    900: { value: '#380D0E' },
  },
  orange: {
    DEFAULT: { value: '#F06710' },
    500: { value: '#F06710' },
    600: { value: '#CA5F1C' },
    800: { value: '#5B3F36' },
  },
  yellow: {
    DEFAULT: { value: '#F1CD2D' },
    500: { value: '#F1CD2D' },
    800: { value: '#5D5A37' },
  },
  green: {
    DEFAULT: { value: '#13A813' },
    500: { value: '#13A813' },
    800: { value: '#1B4F2F' },
  },
  blue: {
    DEFAULT: { value: '#1561D1' },
    500: { value: '#1561D1' },
    600: { value: '#0B41AB' },
    700: { value: '#16326A' },
    800: { value: '#132853' },
    900: { value: '#091938' },
  },
  skyBlue: {
    DEFAULT: { value: '#4FA4E7' },
    500: { value: '#4FA4E7' },
  },
  stormBlue: {
    DEFAULT: { value: '##1A4686' },
    600: { value: '##1A4686' },
    '600-op15': { value: '#1A468626' },
    '600-op30': { value: '#1A46864D' },
  },
  purple: {
    DEFAULT: { value: '#B18FEB' },
    500: { value: '#B18FEB' },
    600: { value: '#6A48A0' },
    800: { value: '#4A486F' },
  },
} as const;

export const semanticColors = {
  alertHi: {
    DEFAULT: { value: 'colors.red.500' },
    500: { value: 'colors.red.500' },
    800: { value: 'colors.red.800' },
  },
  alertMid: {
    DEFAULT: { value: 'colors.orange.500' },
    500: { value: 'colors.orange.500' },
    800: { value: 'colors.orange.800' },
  },
  alertLo: {
    DEFAULT: { value: 'colors.yellow.500' },
    500: { value: 'colors.yellow.500' },
    800: { value: 'colors.yellow.800' },
  },
  alertZero: { DEFAULT: { value: 'colors.green.500' }, 500: { value: 'colors.green.500' } },
  alertHs: {
    DEFAULT: { value: 'colors.purple.500' },
    500: { value: 'colors.purple.500' },
    800: { value: 'colors.purple.800' },
  },
} as const;
